// extracted by mini-css-extract-plugin
module.exports = {"form":"views-Subscribe__form--2rdGe","wrapper":"views-Subscribe__wrapper--1mHNM"};